import { ACCOUNT_FACILITY_ACTIONS } from "constants";

export const createFacilityAccount = (caseId, accountData, supplyChainData) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.CREATE_FACILITY_ACCOUNT,
        payload: {
            accountData,
            caseId,
            supplyChainData
        }
    };
};

export const createdFacilityAccount = (caseId, accountData) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.CREATED_FACILITY_ACCOUNT,
        payload: {
            accountData,
            caseId
        }
    };
};

export const failedCreateFacilityAccounts = (error) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.FAILED_CREATE_FACILITY_ACCOUNT,
        error
    };
};

export const fetchFacilityAccount = (caseId) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.FETCH_FACILITY_ACCOUNT,
        payload: {
            caseId
        }
    };
};

export const fetchedFacilityAccount = (caseId, accountData) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.FETCHED_FACILITY_ACCOUNT,
        payload: {
            accountData,
            caseId
        }
    };
};

export const failedFetchFacilityAccounts = (error) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.FAILED_FETCH_FACILITY_ACCOUNT,
        error
    };
};

export const fetchFacilityAccountSupplyChains = (caseId) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.FETCH_SUPPLY_CHAINS_LIST,
        payload: {
            caseId
        }
    };
};

export const fetchedFacilityAccountSupplyChains = (caseId, supplychainData) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.FETCHED_SUPPLY_CHAINS_LIST,
        payload: {
            supplychainData,
            caseId
        }
    };
};

export const failedFetchFacilityAccountSupplyChains = (error) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.FAILED_FETCH_SUPPLY_CHAINS_LIST,
        error
    };
};

export const updateFacilityAccountSupplyChains = (caseId, supplychainData) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.UPDATE_SUPPLY_CHAINS_LIST,
        payload: {
            supplychainData,
            caseId
        }
    };
};

export const updatedFacilityAccountSupplyChains = (caseId, supplychainData) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.UPDATED_SUPPLY_CHAINS_LIST,
        payload: {
            supplychainData,
            caseId
        }
    };
};

export const failedUpdateFacilityAccountSupplyChains = (error) => {
    return {
        type: ACCOUNT_FACILITY_ACTIONS.FAILED_UPDATE_SUPPLY_CHAINS_LIST,
        error
    };
};